import {
  createStyleMixin,
  draggableMixin,
  componentNameValidationMixin,
} from '@descope-ui/common/components-mixins';
import { createBaseClass } from '@descope-ui/common/base-classes';
import { compose } from '@descope-ui/common/utils';
import {
  forwardAttrs,
  getComponentName,
  injectStyle,
  observeAttributes,
} from '@descope-ui/common/components-helpers';

export const componentName = getComponentName('avatar');
class RawAvatar extends createBaseClass({
  componentName,
  baseSelector: ':host > .wrapper',
}) {
  constructor() {
    super();

    this.attachShadow({ mode: 'open' }).innerHTML = `
      <div class="wrapper">
        <vaadin-avatar></vaadin-avatar>
        <div class="editableBadge">
          <vaadin-icon icon="vaadin:pencil"></vaadin-icon>
        </div>
      </div>
		`;

    injectStyle(`
        :host {
					display: inline-flex;
				}

        .editableBadge {
          border: 1px solid;
          border-radius: 100%;
          height: fit-content;
          width: 25%;
          height: 25%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 5%;
          box-sizing: border-box;
          position: absolute;
          bottom: 0;
          inset-inline-end: 0;
        }

        vaadin-icon {
          color: currentcolor;
        }

        vaadin-avatar {
          width: 100%;
          height: 100%;
          margin: 0;
          border: none
        }

        .wrapper {
          display: inline-flex;
          position: relative;
          width: 100%;
          height: 100%;
        }
    `, this);

    this.avatarComponent = this.shadowRoot.querySelector('vaadin-avatar');

    forwardAttrs(this, this.avatarComponent, {
      includeAttrs: ['display-name', 'img', 'abbr'],
      mapAttrs: { 'display-name': 'name' },
    });

    const editableIcon = this.shadowRoot.querySelector('.editableBadge');

    observeAttributes(
      this,
      () => {
        editableIcon.style.display = this.isEditable ? '' : 'none';
      },
      { includeAttrs: ['editable'] },
    );
  }

  get isEditable() {
    return this.getAttribute('editable') === 'true';
  }
}

const { host, editableBadge, avatar } = {
  host: { selector: () => ':host' },
  editableBadge: { selector: '> .editableBadge' },
  avatar: { selector: 'vaadin-avatar' },
};

export const AvatarClass = compose(
  createStyleMixin({
    mappings: {
      hostWidth: [
        { ...host, property: 'width' },
        { ...host, property: 'min-width' },
      ],
      hostHeight: { ...host, property: 'height' },
      cursor: [avatar, host],
      hostDirection: { ...host, property: 'direction' },
      avatarTextColor: { ...avatar, property: 'color' },
      avatarBackgroundColor: { ...avatar, property: 'background-color' },
      editableIconColor: { ...editableBadge, property: 'color' },
      editableBorderColor: { ...editableBadge, property: 'border-color' },
      editableBackgroundColor: {
        ...editableBadge,
        property: 'background-color',
      },
    },
  }),
  draggableMixin,
  componentNameValidationMixin,
)(RawAvatar);
